export default {
    postaw_na: 'Choose',
    profesjonalistow: 'professionals',
    oferta:'Offer',
    o_nas:'About us',
    realizacje:'Realizations',
    zaufali_nam:'Trusted us',
    kontakt:'Contact',
    wspolpracujemy_z:'We work with an experienced and highly qualified technical team that will ensure solid and timely implementation of the project.',
    sprawdz_oferte:'Check the offer',
    nasza_oferta:'Our offer',
    nasza_oferta_obejmuje:'Our offer includes professional service of aluminum facades, production of aluminum constructions as well as services related to delivery and assembly.',
    serwis_elewacji_aluminiowych:'Service of aluminum facades',
    potrzebujesz_kompleksowego:'Do you need a comprehensive service or expert opinion on the technical condition of aluminum facade elements?',
    szczegoly:'Details',
    konstrukcje_aluminiowe:'Aluminum structures',
    w_naszej_ofercie:'Our offer includes sliding windows and doors, glass facades and winter gardens',
    dodatkowe_uslugi:'Additional services',
    nasza_firma_oferuje:'Our company also offers delivery and assembly of glass-aluminum facades, architectural elements and sandwich panels',
    kim_jestesmy:'Who we are?',
    jestesmy_firma:'“We are a socially responsible company. We believe that our business activities have an impact on the society in which we operate. That is why we support various social initiatives both at the global and local level.”',
    wlasciciel_firmy:'Owner of the MTD Company',
    zrealizowane_projekty:'Completed projects',
    przedstawiamy_panstwu:'We present you some of our completed projects.',
    rozbudowa_budynku:'Extension of the building of the Foundation for Polish Science',
    zlecenodawca_cushman:'Customer: Cushman&Wakefield',
    prefabrykacja_i_instalacja_swietlikow:'Prefabrication and installation of aluminum skylights in the Schuco system',
    budynek_biurowy_focus:'Focus Office Building Aleja Armii Ludowej 26, Warszawa',
    naprawa_i_konserwacja_slusarki_aluminiowej:'Repair and maintenance of aluminum fittings. Replacement of insulating glass units on the facade and roof of the Atrium. Liquidation of water leaks',
    hotel_intercontinental:'InterContinental Hotel Warszawa',
    zleceniodawca_riskotes:'Customer: RisKotes/Alumen',
    przeglad_elewacji_oraz_wykonanie_projektu:'Review of the facade and preparation of a repair project of the facade made of Alucobond cassettes',
    wieza_kontroli_lotow:'Control tower ul. Wieżowa 8, Warszawa II',
    zleceniodawca_pazp:'Customer:  PAŻP',
    wymiana_szyb_zespolonych:'Replacement of insulating glass in the air traffic control tower',
    zobacz_wiecej:'SEE MORE',
    inwestor_indywidualny:'Individual investor',
    przeglad_elewacji_oraz_wykonanie_projektu_naprawy:'Delivery and assembly of aluminum windows.',
    marszalkowska:'Marszałkowska 76',
    serwis_i_naprawy_slusarki:'Service and repair of aluminum fittings. Replacement of facade panels and insulating glass units',
    wieza_widokowa:'Viewing tower in Gniewino',
    zleceniodawca_eiffage:'Customer:  Eiffage Budownictwo Mitex S.A.',
    naprawa_i_konserwacja_konstrukcji:'Repair and maintenance of the steel structure of the stays',
    hurtownia_kosmetykow:'Wholesale of cosmetics and medicines in Warsaw-Wesoła at ul. Wspólna 1',
    zleceniodawca_:'Customer: Ziaja',
    elewacja_z_plyt:'Elevation made of Ruukki SP2D100PIR sandwich panels, elevation made of LIBERTA 500 GRANDE wall cassettes',
    na_przestrzeni_lat:'Over the years, thanks to our professional approach and timely services, we have earned the reputation of a solid and reliable partner among our regular customers.',
    glowny_inzynier:'Chief engineer at KASKADA Sp. Z o.o.',
    czlonek_zarzadu:'Member of the Management Board, Operational Director at Mennica Polska S.A.',
    prodziekan_wydzialu:'Deputy Dean of the Faculty of Materials Science and Engineering of the Warsaw University of Technology',
    zarzadca_nieruchomosci:'Property manager W Cushman & Wakefield Polska Sp. Z o.o.',
    mamy_nadzieje:'We hope that the group of our satisfied customers will keep growing. We invite you to cooperation!',
    menu:'Menu',
    okna_i_drzwi_przesuwne: 'Windows and sliding doors',
    fasady_szklane: 'Glass facades',
    ogrody_zimowe: 'Winter gardens',
    systemy_okien_i_drzwi_przesuwnych: 'Window and sliding door systems create a spatial connection between the interior and the exterior. They provide us with an unlimited view outside. The space expands, fresh air flows in and the view becomes unlimited.',
    zobacz_galerie: 'See the gallery',
    okna: 'Windows',
    wszystkie_odmiany_okien: 'All varieties of windows are based on',
    systemow_aluprof: ' Schüco, Aluprof, Yawal systems',
    okucia_dobierane: 'Okucia dobierane indywidualnie pod wymiary skrzydeł i ich ciężary',
    obsluga_w_sposob: 'Traditional service -',
    manualnie_oraz_mechatronicznie: ' manually and mechatronic (electric) windows and doors',
    mozemy_zapewnic: 'We can provide electronic monitoring of window closure, natural and automatic ventilation.',
    okna_aluminiowe: 'Aluminum windows (Super Insulation) with high thermal insulation in the standard of passive construction.',
    odpornosc_na_wlamania: 'Burglary resistance up to RC class 4',
    ciezar_skrzydel: 'Weight of window and door sashes up to 250 kg',
    drzwi_wejsciowe: 'Entrance doors, paneled, glazed, ',
    z_kontrola_dostepu: 'with access control (fingerprint)',
    szyby_trzyszybowe: 'Glass: triple-glazed with solar energy access control inside the room',
    lakierowanie_na_dowolnej_palecie: 'Varnishing in any color palette: RAL, NCS, wood-like and anodizing',
    czytaj_wiecej: 'Read more',
    drzwi_przesuwne: 'Sliding doors',
    wszystkie_odmiany_drzwi: 'All varieties of doors ',
    wysokosc_skrzydel: 'Wing height up to 3.5 m',
    dla_wiekszego_komfortu: ' For greater comfort of use, sliding systems with mechatronic fittings can be easily',
    obslugiwane_za_pomoca: ' operated with a tablet, smartphone or button.',
    wyposazenie_drzwi_przesuwnych: 'Equipping sliding doors with an integrated opening and closing control system, with feedback to the electronic system when leaving the building',
    system_kontroli_otwarcia: 'The opening and closing control system can be additionally equipped with an interface for connection to the building automation and alarm system',
    izolacyjnosc_ponizej: 'Insulation below Uw = 1.0',
    prog_zlicowany: 'The threshold is flush with the floor level',
    ukryte_ramy: 'Concealed sliding door frames in walls and ceilings',
    ciezar_skrzydel: 'Weight of sliding sashes up to 600 kg',
    systemy_schuco: 'Schüco systems',
    jestesmy_producentem_okien: 'We are a producer of windows, doors and winter gardens in Schüco systems',
    w_naszej_ofercie_znajda: 'Our offer includes:',
    fasady_aluminiowo_szklane: 'aluminum and glass semi-structural and structural facades',
    okna_fasadowe: 'Traditional, structural, parallel opening facade windows',
    informacje_techniczne: 'Technical informations',
    proponujemy_naszym_klientom: 'We offer our clients glazing tailored to individual needs, which are perfect as elements of the construction of winter gardens or roofed terraces. We offer:',
    ogrody_zimowe_2: 'winter gardens',
    oranzerie: 'orangeries',
    inne_zadaszenia: 'other glass roofs',
    pracujemy_na_najwyzszej: 'We work on the highest quality aluminum systems of companies',
    schuco_aluprof: ' Schüco, Aluprof, Yawal.',
    oferujemy_szklo: 'We offer glass with solar energy access control to reduce the greenhouse effect and garden ventilation systems to improve the indoor climate.',
    zakres_uslug: 'The scope of aluminum facade service',
    serwis_konserwacja: 'Service, maintenance and repair of aluminum facades',
    profesjonalne_przeglady: 'Professional inspections of facade elements',
    wykonanie_opinii: 'Preparation of opinions and expert opinions on the technical condition of the facade elements',
    dostawa_i_montaz: 'Delivery and installation of all types of insulating glass on buildings',
    zakres_dodatkowych: 'Scope of additional services',
    dostawa_i_montaz_plyt: 'Delivery and assembly of Ruukki sandwich panels,',
    dostawa_i_montaz_elementow: 'Delivery and assembly of architectural elements by Hunter Douglas,',
    montaz_elewacji: 'Installation of glass and aluminum facades.'

  }